import { can, SessionLike } from "./can.ts";

type AppRoute = {
  requiredPermission?: string;
  roles?: unknown;
  validRoles?: unknown;
  children?: AppRoute[];
  [key: string]: unknown;
};

function allow(route: AppRoute, session: SessionLike): boolean {
  if (route?.requiredPermission) {
    return can(route.requiredPermission, session);
  }
  return !route?.roles && !route?.validRoles;
}

function cloneRoute(route: AppRoute): AppRoute {
  return {
    ...route,
    children: route.children?.map(cloneRoute),
  };
}

function filterNode(route: AppRoute, session: SessionLike): AppRoute | null {
  if (route.children) {
    const children = route.children
      .map((child) => filterNode(child, session))
      .filter((child): child is AppRoute => child !== null);
    if (children.length > 0 || allow(route, session)) {
      return { ...route, children };
    }
    return null;
  }
  return allow(route, session) ? { ...route } : null;
}

/** Filtra una copia. La tabla original sigue intacta para el siguiente render. */
export function filterRoutes(routes: AppRoute[], session: SessionLike): AppRoute[] {
  return routes
    .map(cloneRoute)
    .map((route) => filterNode(route, session))
    .filter((route): route is AppRoute => route !== null);
}
